export default "__VITE_ASSET__BQthD68y__"